import React from "react";
import Skeleton from "../../../components/Skeleton";
import { getWindowWidth, isMobileScreen } from "../../../services/utils";

export const CreditPackagesLoading = () => {
  const isMobile = isMobileScreen(getWindowWidth());

  return (
    <React.Fragment>
      <Skeleton style={{ height: 20, width: 200 }} />
      <Skeleton style={{ height: 40, marginTop: 20 }} />
      <Skeleton style={{ height: 20, width: 200, marginTop: 20 }} />
      <div style={{ marginTop: 20, display: "flex", flexWrap: isMobile ? "wrap" : "nowrap", justifyContent: "center" }}>
        <Skeleton style={{ height: 133, width: isMobile ? "40%" : 133 }} />
        <Skeleton style={{ height: 133, width: isMobile ? "40%" : 133 }} />
        <Skeleton style={{ height: 133, width: isMobile ? "40%" : 133 }} />
        <Skeleton style={{ height: 133, width: isMobile ? "40%" : 133 }} />
        <Skeleton style={{ height: 133, width: isMobile ? "40%" : 133 }} />
        <Skeleton style={{ height: 133, width: isMobile ? "40%" : 133 }} />
      </div>
      <Skeleton style={{ height: 40, marginTop: 20, width: 200, marginLeft: "auto" }} />
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/containers/CreditsPage/CreditPackages/CreditPackagesLoading.tsx